<template>
    <purchase-sector title="추천인 코드">
        <div class="purchase-code">
            <v-sheet color="grey lighten-3" class="pa-6">
                <v-text-field v-model="code" outlined hide-details class="white" placeholder="추천인 코드를 입력하세요" @input="emit" />
            </v-sheet>
        </div>
    </purchase-sector>
</template>

<script>
import PurchaseSector from "./purchase-sector.vue";

export default {
    components: {
        PurchaseSector,
    },
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        code: null,
    }),
    computed: {},
    methods: {
        sync() {
            this.code = this.value;
        },
        emit() {
            this.$emit("input", this.code);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.purchase-code {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>
